const DeliveryStatuses = {
    PROCESSING: 'PROCESSING',
    SENT: 'SENT',
    SCHEDULED: 'SCHEDULED',
    CANCELLED: 'CANCELLED',
    FAILED: 'FAILED',
  }
  
  export default DeliveryStatuses